import { render, staticRenderFns } from "./PickingItems.vue?vue&type=template&id=1a8990a6&scoped=true&"
import script from "./PickingItems.vue?vue&type=script&lang=ts&"
export * from "./PickingItems.vue?vue&type=script&lang=ts&"
import style0 from "./PickingItems.vue?vue&type=style&index=0&id=1a8990a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8990a6",
  null
  
)

export default component.exports